export type SolarStatus = 'IDLE' | 'PRODUCTION' | 'ERROR';

// This constant controls the threshold for solar to be considered '0' in the UI -- this is to help account for noise
export const SOLAR_UI_THRESHOLD_KW = 0.01;
